import React        from "react";
import classnames   from 'classnames';
import numeral      from "numeral";

import Alert        from 'react-bootstrap/Alert';

const BomSummary = (props) => {

  const { 
    selected_board_qty,
    totals,
    base_totals,
    markups,
    tariffs,
    shipping,
  } = props;

  if(!totals || _.isEmpty(totals)) return null

  return (
    <Alert className="bom-summary">
      <div className="row">
        <div className={classnames("", {
          "col-3": tariffs && !_.isEmpty(tariffs) && tariffs[selected_board_qty] > 0,
          "col-4": !tariffs || _.isEmpty(tariffs) || !tariffs[selected_board_qty] || tariffs[selected_board_qty] <= 0,
        })}>
          <div className="d-flex justify-content-end">
            <div className="row summary-text w-100">
              <div className="col-8 text-end boards">
                Part cost for all {selected_board_qty} boards:
              </div>
              <div className="col-4 text-end totals">
                ${numeral((base_totals[selected_board_qty] * (1 + markups[selected_board_qty]))).format('0.00')}
              </div>
            </div>
          </div>
        </div>
        <div className={classnames("", {
          "col-3": tariffs && !_.isEmpty(tariffs) && tariffs[selected_board_qty] > 0,
          "col-4": !tariffs || _.isEmpty(tariffs) || !tariffs[selected_board_qty] || tariffs[selected_board_qty] <= 0,
        })}>
          <div className="d-flex justify-content-end">
            <div className="row summary-text w-100">
              <div className="col-7 text-end boards">
                Shipping cost:
              </div>
              <div className="col-5 text-end totals">
                ${numeral(shipping[selected_board_qty]).format('0.00')}
              </div>
            </div>
          </div>
        </div>
        { tariffs && !_.isEmpty(tariffs) && tariffs[selected_board_qty] > 0 && 
          <div className="col-3">
            <div className="d-flex justify-content-end">
              <div className="row summary-text w-75">
                <div className="col-7 text-end boards">
                  Est. Tariff: 
                </div>
                <div className="col-5 text-end totals">
                  ${numeral(tariffs[selected_board_qty]).format('0.00')}
                </div>
              </div>
            </div>
          </div>
        }
        <div className={classnames("", {
          "col-3": tariffs && !_.isEmpty(tariffs) && tariffs[selected_board_qty] > 0,
          "col-4": !tariffs || _.isEmpty(tariffs) || !tariffs[selected_board_qty] || tariffs[selected_board_qty] <= 0,
        })}>
          <div className="d-flex justify-content-end">
            <div className="row summary-text w-75">
              <div className="col-6 text-end boards">
                Total:
              </div>
              <div className="col-6 text-end totals">
                ${numeral(totals[selected_board_qty]).format('0.00')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Alert>
  )
}

export default BomSummary;